module.exports = __webpack_public_path__ + "static/images/3c350fd32ca5a59857d778871abc228b.png";